export const API_KEY = "AIzaSyCt__FjW5hzoWKWlu8h-kqncf6fKc2ThKw"


export default API_KEY